<template>
    <div class="bg-white mt-3 p-3 progress-status-view activity-type-create col-12">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-3">
                <button v-b-tooltip.hover :title="$backLabel()" id="cancle-label-btn" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('rpa_templates') }}</span>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm">
            <b-card no-body>
                <b-tabs card v-model="tabIdx">
                    <b-tab title="Summary" active>
                        <b-card-body>
                            <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                                <b-row>
                                    <b-col cols="12" md="6" class="mt-3 dd">
                                        <label class="mb-3" for="input-order_type_id-rpat"><strong>{{
                                            $translate('activity_type')
                                                }}</strong><span class="red">*</span></label>
                                        <b-form-select class="form-control" id="input-order_type_id-rpat"
                                            value-field="id" text-field="name" v-model="model.order_type_id"
                                            :options="orderTypes">
                                            <template #first>
                                                <b-form-select-option :value="null">{{ $translate('select_type')
                                                    }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-name-rpat"><strong>{{ $translate('name')
                                                }}</strong><span class="red">*</span></label>
                                        <b-form-input class="form-control" id="input-name-rpat" v-model="model.name"
                                            :placeholder="$translate('name')">
                                        </b-form-input>
                                    </b-col>

                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-description-rpat">
                                            <strong>{{ $translate('description') }}</strong>
                                            <span class="red">*</span>
                                        </label>
                                        <b-form-input class="form-control" id="input-description-rpat"
                                            v-model="model.description" :placeholder="$translate('description')">
                                        </b-form-input>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-erp_vendor_id-rpat">
                                            <strong>{{ $translate('erp_vendor_id') }}</strong>
                                            <span class="red">*</span>
                                        </label>
                                        <b-form-input class="form-control" id="input-erp_vendor_id-rpat"
                                            v-model="model.erp_vendor_id" :placeholder="$translate('erp_vendor_id')">
                                        </b-form-input>
                                    </b-col>



                                    <b-col cols="12" md="6" class="mt-3 dd">
                                        <label class="mb-3" for="input-rpa_integration_code-rpat">
                                            <strong>{{ $translate('rpa_integration_code') }}</strong>
                                            <span class="red">*</span>
                                        </label>
                                        <b-form-select class="form-control" id="input-rpa_integration_code-rpat"
                                            v-model="model.rpa_integration_code" :options="rpa_integration_codes">
                                            <template #first>
                                                <b-form-select-option :value="null">{{
                                                    $translate("select_rpa_integration_code")
                                                    }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>

                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-gl_integration_code-rpat">
                                            <strong>{{ $translate('gl_integration_code') }}</strong>
                                            <span class="red">*</span>
                                        </label>
                                        <b-form-input class="form-control" id="input-gl_integration_code-rpat"
                                            v-model="model.gl_integration_code"
                                            :placeholder="$translate('gl_integration_code')">
                                        </b-form-input>
                                    </b-col>

                                    <b-col cols="12" md="6" class="mt-3">
                                        <label class="mb-3" for="input-erp_code-rpat">
                                            <strong>{{ $translate('erp_code') }}</strong>
                                            <span class="red">*</span>
                                        </label>
                                        <b-form-input class="form-control" id="input-erp_code-rpat"
                                            v-model="model.erp_code" :placeholder="$translate('erp_code')">
                                        </b-form-input>
                                    </b-col>

                                </b-row>
                                <b-col md="12" class="mb-2 mt-3 text-center">
                                    <b-button id="create-rpa-template-btn" class="btn btn-info btn-fw me-2"
                                        type="submit" v-if="hasPermissionCreate && !model.id" variant="primary"
                                        :disabled="loading ? true : false">{{
                                            createLabel
                                        }}</b-button>
                                    <b-button id="update-rpa-template-btn" class="btn btn-info btn-fw me-2"
                                        type="submit" v-if="hasPermissionUpdate && model.id" variant="primary"
                                        :disabled="loading ? true : false">{{
                                            updateLabel
                                        }}</b-button>
                                    <b-button id="delete-rpa-template-btn" v-if="!!this.model.id && hasPermissionDelete"
                                        @click="deleteItem()" size="fw" class="me-2" variant="delete-button">
                                        {{ $translate('delete_item') }}
                                    </b-button>
                                    <b-button id="cancel-rpa-template-btn" variant="info"
                                        :disabled="loading ? true : false" @click="cancel()" class="btn-fw">
                                        {{ $cancelLabel() }}
                                    </b-button>
                                </b-col>
                            </b-form>
                        </b-card-body>
                    </b-tab>
                    <b-tab title="Items">
                        <b-card-body class="p-0">
                            <template-items v-if="tabIdx === 1" />
                        </b-card-body>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-overlay>
    </div>
</template>http://localhost:8080/#
<script>
import { capitalCase } from 'change-case'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TemplateItems from './TemplateItems'

export default {
    name: 'RpaTemplates-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    components: {
        TemplateItems,
    },
    props: ["item"],
    data() {
        return {
            tabIdx: 0,
            model: {
                id: 0,
                order_type_id: null,
                name: null,
                description: null,
                erp_vendor_id: null,
                rpa_integration_code: null,
                gl_integration_code: null,
                erp_code: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },
        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },


        orderTypes() {
            return this.$store.getters["orderType/activityTypesByPermission"];
        },

        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },

        rpa_integration_codes() {
            return this.$store.getters['rpaTemplate/rpa_integration_codes']
        },


    },
    watch: {},
    async mounted() {
        this.loading = true
        await this.$store.dispatch("orderType/fetchAll");
        if (this.item.id) {
            this.model = { ...this.item }
        }
        this.loading = false
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        async onSubmit() {

            const NOT_VALIDATED = "Not Validated!";

            try {
                this.loading = true
                const model = { ...this.model }
                console.log('model', model)
                const action = model.id ? 'update' : 'create'
                const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
                const path = `rpaTemplate/${action}`
                const valid = await this.$validator.validate()
                if (!valid) throw NOT_VALIDATED;
                await this.$store.dispatch(path, model)
                this.$emit('success', action, message)
            } catch (error) {
                if (error !== NOT_VALIDATED) {
                    console.log('error', error)
                    this.$emit('error', error)
                }
            } finally {
                this.loading = false
            }
        },
        async deleteItem() {
            const NOT_CONFIRMED = "Not Confirmed";
            try {

                // Initializing key variables
                console.log('Attempt to delete')
                const model = { ...this.model }
                const path = 'rpaTemplate/delete'
                const action = model.id ? 'update' : 'create'

                // Generate and display confirmation prompt
                const title = this.$translate('delete_rpa_template')
                const message = `${this.$translate('delete_note')}`
                // const errorMsg = 'Unable to delete Progress Status!'
                const alertMsg = this.$translate('delete_alert')
                const result = await this.confirmMessage(title, message)
                if (!result) throw NOT_CONFIRMED;
                this.loading = true;

                await this.$store.dispatch(path, model.id)
                this.$emit(
                    'success',
                    action,
                    alertMsg
                )
            } catch (error) {
                if (error !== NOT_CONFIRMED) {
                    console.error(error)
                    this.loading = false;
                    this.doToast(this.$translate('error'), error.message, 'danger')
                }
            } finally {
                this.loading = false;
            }

        },
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>
